export default __webpack_public_path__ + "static/webinar-backup-9fbcd3677a67939231862552b765b0ac.jpg";